(function () {
  function init() {
    var faqs = document.querySelectorAll('[data-faq-accordion]');
    faqs.forEach(function (faq) {
      if (faq.dataset.faqAccordionReady === 'true') return;
      faq.dataset.faqAccordionReady = 'true';

      var items = faq.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other === item || !other.open) return;
            var disclosure = other.parentElement;
            if (disclosure && typeof disclosure.close === 'function') {
              disclosure.close();
            } else {
              other.removeAttribute('open');
            }
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
